import api from './api';

const adminService = {
    // Get dashboard stats
    getDashboard: async () => {
        try {
            const response = await api.get('/admin/dashboard');
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Get pending approvals
    getPendingPapers: async (page = 1, limit = 20) => {
        try {
            const params = new URLSearchParams({ page, limit });
            const response = await api.get(`/admin/papers/pending?${params}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Get all papers
    getAllPapers: async (filters = {}, page = 1, limit = 20) => {
        try {
            const params = new URLSearchParams({ ...filters, page, limit });
            const response = await api.get(`/admin/papers?${params}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Approve paper
    approvePaper: async (paperId, comment = '') => {
        try {
            const response = await api.post(`/admin/papers/${paperId}/approve`, {
                admin_comment: comment,
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Reject paper
    rejectPaper: async (paperId, reason, comment = '') => {
        try {
            const response = await api.post(`/admin/papers/${paperId}/reject`, {
                rejection_reason: reason,
                admin_comment: comment,
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Delete paper
    deletePaper: async (paperId) => {
        try {
            const response = await api.delete(`/admin/papers/${paperId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Get all users
    getAllUsers: async (page = 1, limit = 50) => {
        try {
            const params = new URLSearchParams({ page, limit });
            const response = await api.get(`/admin/users?${params}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Get all reports
    getAllReports: async (filters = {}, page = 1, limit = 20) => {
        try {
            const params = new URLSearchParams({ ...filters, page, limit });
            const response = await api.get(`/admin/reports?${params}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Get report details
    getReportDetails: async (reportId) => {
        try {
            const response = await api.get(`/admin/reports/${reportId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Resolve report
    resolveReport: async (reportId, adminResponse, actionTaken) => {
        try {
            const response = await api.post(`/admin/reports/${reportId}/resolve`, {
                admin_response: adminResponse,
                action: actionTaken,
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Dismiss report
    dismissReport: async (reportId, adminResponse, resolution) => {
        try {
            const response = await api.post(`/admin/reports/${reportId}/dismiss`, {
                admin_response: adminResponse,
                resolution: resolution,
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Create new admin user
    createAdmin: async (userData) => {
        try {
            const response = await api.post('/admin/users/create-admin', userData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Update user role
    updateUserRole: async (userId, role) => {
        try {
            const response = await api.patch(`/admin/users/${userId}/role`, { role });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Notifications
    getNotifications: async () => {
        try {
            const response = await api.get('/admin/notifications');
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    markNotificationRead: async (notificationId) => {
        try {
            const response = await api.post(`/admin/notifications/${notificationId}/read`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    markAllNotificationsRead: async () => {
        try {
            const response = await api.post('/admin/notifications/read-all');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default adminService;
